// eslint-disable-next-line no-unused-vars
import { IModel } from '@src/js/separate-logic/interface/IModel';
import { AttachmentProps } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import { JSXElementConstructor } from 'react';
import AttachmentUploader from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { AttachmentClassify } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';

export default class AttachmentModel implements IModel {
    private AttachmentComponent: JSXElementConstructor<AttachmentProps>;  // 上传完成之后显示的UI
    private containerID: string;
    private clipPathId: string;
    private isVideoFullScreen: boolean;

    public initModel(props) {
        const { attachment } = props;
        // 有obj key表明上传完成
        if (attachment?.objKey) {
            this.AttachmentComponent = AttachmentUploader.getInstance().getAttachmentComponent();
        }
        // dom id为上传id或objectKey
        this.containerID = `attachment_${attachment?.objKey || attachment?.id}`;
        this.clipPathId = `clipPath_${attachment?.objKey || attachment?.id}`;
        this.isVideoFullScreen = false;
    }
}
